import React from 'react'
import "../styles/Gallery.css"
import background from "../../src/assets/images/background-g.jpg";
import banner from "../../src/assets/images/banner.jpg"
import GalleryData from '../components/Gallery-data/GalleryData';

//import SlideShow from "../components/SlideShow/SlideShow"
//import styled from 'styled-components';

const Gallery = () => {
return (
    
    <div style={{ backgroundImage: `url(${background})` }}>
        <img src={banner} alt="" className="banner_item"/>


        







        <GalleryData/>


    </div>
)
}

export default Gallery